const CardStyle = {
  cardContainer: {
    height: '100px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '18px 14px 17px',
    borderRadius: '16px',
    backgroundColor: '#F4F4F4',
    boxShadow: "10px -10px 30px #FFFFFF, 10px 10px 30px rgba(174, 174, 192, 0.4)",
  },
  center: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  rectangle: {
    width: '18px',
    height: '4px',
    margin: '2px 2px 26px',
    backgroundColor: 'var(--light-gray-3)',
  },
  reason: {
    fontFamily: 'dana',
    fontSize: '12px',
    fontWeight: '700',
    color: 'var(--purply)',
    textAlign:'right'
  },
  meal: {
    textAlign:'right',
    objectFit: 'contain',
    paddingRight: "7px",
  },
  sugarNumber: {
    display: 'flex',
    alignItems: 'center',
    justifyContent:'center',
    fontFamily: 'dana',
    fontSize: '24px',
    fontWeight: '700',
    textAlign: 'center',
  },
  sugarUnit: {
    display: 'flex',
    alignItems: 'center',
    justifyContent:'center',
    // flexDirection: 'column-reverse',
    fontFamily: 'dana',
    fontSize: '14px',
    fontWeight: '400',
    textAlign: 'center',
  }
  ,
  date: {
    fontFamily: 'dana',
    fontSize: '12px',
    fontWeight: '700',
    textAlign: 'left',
    color: '#3CC0C3',
    letterSpacing: '1px',
  },
  clock: {
    display:'flex',
    justifyContent:'end',
    direction:'rtl',
    fontFamily: 'dana',
    fontSize: '20px',
    fontWeight: '400',
    letterSpacing: '1px',
    textAlign: 'center',
    color: '#3CC0C3',
  },
  secondRowContainer:{
    display: 'flex',
    alignItems: 'end',
    // marginTop: '5px',
  },
  fiberStyle:{
    width: '8px !important',
    height: '8px !important',
    marginLeft: '6px !important'
  }
};

export default CardStyle;
